import { IDotXetChungChiThamSoXetActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiThamSoXet";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetChungChiThamSoXetReducer } from "../../reducer-model/xet-chung-chi/IDotXetChungChiThamSoXetReducer";

const iniState: IDotXetChungChiThamSoXetReducer = {
    status: eReducerStatusBase.is_not_initialization,
    thamSoXets: [],
    thamSoXetChuaThems: [],
}

export const dotXetChungChiThamSoXetReducer = (state: IDotXetChungChiThamSoXetReducer = iniState, action: IDotXetChungChiThamSoXetActionTypes): IDotXetChungChiThamSoXetReducer => {
    switch (action.type) {
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thamSoXets: action.payload
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_NOT_EXISTS_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_NOT_EXISTS_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thamSoXetChuaThems: action.payload
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_LOAD_NOT_EXISTS_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_THAM_SO_XET_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        
        default:
            return state;
    }
};